export enum ResistanceUnitMode {
  POWER_TARGET = 'powerTarget',
  RESISTANCE_LEVEL = 'resistanceLevel',
  EXTERNAL = 'external',
}

export enum ResistanceModalText {
  ENTER = 'enter',
  LEAVE = 'leave',
}
